import { VariantProps, cva } from 'class-variance-authority';
import { DetailedHTMLProps, ForwardedRef, HTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './List.module.scss';

const listVariants = cva(
    [
        'bg-floating-color border border-[#F4F5F7] dark:border-grayscale-50',
        'shadow-[0px_2px_32px_-4px_rgba(3,17,22,0.1)] dark:shadow-[0px_2px_32px_-4px_rgba(3,17,22,0.8)]',
        'rounded-lg outline-none py-2',
        'overflow-y-auto',
        'empty:hidden',
        styles['list'],
    ],
    {
        variants: {
            divider: {
                true: 'divide-y divide-separator-color-light',
                false: '',
            },
        },
        defaultVariants: {
            divider: false,
        },
    }
);

interface ListProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>,
        VariantProps<typeof listVariants> {
    ref?: ForwardedRef<HTMLUListElement>;
}

const List = forwardRef<HTMLUListElement, ListProps>((props, ref) => {
    const { children, divider, className, ...rest } = props;

    return (
        <ul {...rest} ref={ref} className={twMerge(listVariants({ divider, className }))}>
            {children}
        </ul>
    );
});

export default List;
